import type Gate from '../model/Gate'

export function nextUnreachedGate(gates: Gate[], teamProgress: number): Gate | undefined {
  return gates
    .filter((gate) => teamProgress < gate.checkpoint.threshold)
    .sort((a, b) => a.checkpoint.threshold - b.checkpoint.threshold)[0]
}

export function rmsUntilNextGate(gates: Gate[], teamProgress: number): number | null {
  const gate = nextUnreachedGate(gates, teamProgress)
  if (!gate) return null
  return gate.checkpoint.threshold - teamProgress
}

export function capRmsAtNextGate(
  proposedRms: number,
  room: number | null,
): { creditedRms: number; cutRms: number } {
  if (room == null || proposedRms <= room) return { creditedRms: proposedRms, cutRms: 0 }
  return { creditedRms: room, cutRms: proposedRms - room }
}

export function gateRequiredSubmissions(gate: Gate, teamMemberCount: number): number {
  if (gate.completionRule === 'min_members') {
    return gate.requirementValue ?? teamMemberCount
  }
  return teamMemberCount
}

export function isGateCleared(
  gate: Gate,
  completedUserIds: Iterable<string>,
  teamMemberCount: number,
): boolean {
  return new Set(completedUserIds).size >= gateRequiredSubmissions(gate, teamMemberCount)
}

export function gateCompletionUserIds(
  gate: Gate,
  submissions: { gateId: string; userId: string }[],
): string[] {
  return submissions
    .filter((submission) => submission.gateId === gate.id)
    .map((submission) => submission.userId)
}
